import { useState } from 'react';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';
import { SEO } from '../../utils/seo';

export function PromotionPage() {
  const [selectedCategory, setSelectedCategory] = useState('alle');

  const categories = [
    { id: 'alle', name: 'Alle Artikel' },
    { id: 'schreibwaren', name: 'Schreibwaren' },
    { id: 'buero', name: 'Bürobedarf' },
    { id: 'textilien', name: 'Textilien' },
    { id: 'technik', name: 'Technik' }
  ];

  const products = [
    {
      id: 1,
      category: 'buero',
      name: 'Becher',
      description: 'Hochwertige Becher mit Ihrem Logo. Perfekt für Büros, Events und als Werbegeschenk.',
      features: ['Verschiedene Materialien', 'Spülmaschinenfest', 'Großer Druckbereich', 'Langlebig'],
      image: 'https://public.readdy.ai/ai/img_res/21e0063afbcecca3710c64de9e97dc77.jpg',
      sizes: ['250ml', '300ml', '350ml']
    },
    {
      id: 2,
      category: 'buero',
      name: 'Notizbuch',
      description: 'Elegante Notizbücher mit Ihrem Firmenlogo. Ideal für Meetings und als Geschenk.',
      features: ['Hochwertige Bindung', 'Verschiedene Größen', 'Liniert/Blanko', 'Hardcover/Softcover'],
      image: 'https://readdy.ai/api/search-image?query=branded%20promotional%20notebook%20journal%20with%20custom%20company%20logo%20embossed%20cover%2C%20corporate%20stationery%20on%20clean%20white%20background%2C%20business%20gift&width=400&height=500&seq=notizbuch-001&orientation=portrait',
      sizes: ['A5', 'A6', 'B5']
    },
    {
      id: 3,
      category: 'textilien',
      name: 'Firmenbekleidung',
      description: 'Maßgeschneiderte Arbeitskleidung mit Ihrem Branding. Professionelles Auftreten für Ihr Team.',
      features: ['Hochwertige Stoffe', 'Alle Größen', 'Stick oder Druck', 'Verschiedene Modelle'],
      image: 'https://readdy.ai/api/search-image?query=branded%20corporate%20workwear%20uniform%20polo%20shirt%20with%20embroidered%20company%20logo%2C%20professional%20business%20clothing%20on%20clean%20white%20background&width=400&height=500&seq=firmenbekleidung-001&orientation=portrait',
      sizes: ['S', 'M', 'L', 'XL', 'XXL']
    },
    {
      id: 4,
      category: 'schreibwaren',
      name: 'Kugelschreiber',
      description: 'Elegante Kugelschreiber mit Ihrem Firmenlogo. Der Klassiker unter den Werbeartikeln.',
      features: ['Hochwertige Verarbeitung', 'Verschiedene Farben', 'Langlebig', 'Großer Druckbereich'],
      image: 'https://readdy.ai/api/search-image?query=collection%20of%20branded%20promotional%20pens%20with%20custom%20logo%2C%20corporate%20business%20writing%20instruments%20on%20clean%20white%20background%2C%20office%20supplies&width=400&height=500&seq=kugelschreiber-001&orientation=portrait',
      sizes: ['Standard', 'Premium']
    },
    {
      id: 5,
      category: 'buero',
      name: 'Visitenkarten',
      description: 'Professionelle Visitenkarten mit hochwertigem Druck. Der erste Eindruck zählt.',
      features: ['Premium Papier', 'Verschiedene Veredelungen', 'Matt/Glänzend', 'Schnelle Lieferung'],
      image: 'https://readdy.ai/api/search-image?query=stack%20of%20premium%20business%20cards%20with%20custom%20company%20logo%20and%20design%2C%20professional%20corporate%20stationery%20on%20clean%20white%20background&width=400&height=500&seq=visitenkarten-001&orientation=portrait',
      sizes: ['85x55mm', '90x50mm']
    },
    {
      id: 6,
      category: 'technik',
      name: 'USB-Stick',
      description: 'Praktische USB-Sticks mit Ihrem Logo. Nützlich und immer im Einsatz.',
      features: ['Verschiedene Speichergrößen', 'Schnelle Übertragung', 'Kompakt', 'Langlebig'],
      image: 'https://readdy.ai/api/search-image?query=branded%20promotional%20USB%20flash%20drives%20with%20custom%20company%20logo%2C%20corporate%20tech%20giveaway%20items%20on%20clean%20white%20background&width=400&height=500&seq=usb-002&orientation=portrait',
      sizes: ['8GB', '16GB', '32GB', '64GB']
    },
    {
      id: 7,
      category: 'schreibwaren',
      name: 'VIP Kugelschreiber',
      description: 'Exklusive Premium-Kugelschreiber für besondere Anlässe und wichtige Kunden.',
      features: ['Edle Materialien', 'Geschenkverpackung', 'Gravur möglich', 'Luxuriöses Design'],
      image: 'https://readdy.ai/api/search-image?query=luxury%20premium%20executive%20pen%20with%20custom%20engraving%20in%20elegant%20gift%20box%2C%20high-end%20corporate%20gift%20on%20clean%20white%20background&width=400&height=500&seq=vip-kugelschreiber-001&orientation=portrait',
      sizes: ['Executive', 'Prestige']
    }
  ];

  const filteredProducts = selectedCategory === 'alle' 
    ? products 
    : products.filter(product => product.category === selectedCategory);

  const schema = {
    '@type': 'CollectionPage',
    name: 'Promotion-Artikel & Giveaways - Werbeartikel mit Logo',
    description: 'Werbeartikel die begeistern: bedruckte Becher, Notizbücher, Kugelschreiber, USB-Sticks, Visitenkarten und Firmenbekleidung mit Ihrem Logo.',
    mainEntity: {
      '@type': 'ItemList',
      itemListElement: products.map((product, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        item: {
          '@type': 'Product',
          name: product.name,
          description: product.description
        }
      }))
    }
  };

  return (
    <>
      <SEO
        title="Promotion - Werbeartikel & Giveaways mit Logo | Horizon Signage Deutschland"
        description="Werbeartikel die begeistern: bedruckte Becher, Notizbücher, Kugelschreiber, USB-Sticks, Visitenkarten und Firmenbekleidung. Alles mit Ihrem Logo. Hochwertige Promotion-Artikel für B2B-Kunden."
        keywords="Promotion-Artikel, Giveaways, Werbeartikel, bedruckte Becher, Kugelschreiber, USB-Sticks, Firmenbekleidung, Deutschland"
        canonical={`${import.meta.env.VITE_SITE_URL || 'https://example.com'}/promotion`}
        schema={schema}
      />
      <div className="min-h-screen">
        <Header />
        
        <main className="pt-20">
          {/* Hero Section */}
          <section className="py-20 bg-gradient-to-br from-rose-50 to-white">
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
              <div className="text-center">
                <span className="inline-block px-4 py-2 bg-zinc-800 text-white rounded-full text-sm font-semibold uppercase tracking-wider mb-6">
                  <i className="ri-gift-line mr-2"></i>
                  Promotion
                </span>
                <h1 className="text-5xl lg:text-6xl font-bold text-zinc-800 leading-tight mb-6">
                  <span className="block">Promotion-Artikel</span>
                  <span className="block text-gray-600">& Giveaways</span>
                </h1>
                <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
                  Werbeartikel die begeistern - von bedruckten T-Shirts über 
                  Kugelschreiber bis hin zu individuellen Giveaways. Alles mit Ihrem Logo.
                </p>
              </div>
            </div>
          </section>

          {/* Category Filter */}
          <section className="py-8 bg-white border-b border-gray-200">
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
              <div className="flex flex-wrap justify-center gap-4">
                {categories.map((category) => (
                  <button
                    key={category.id}
                    onClick={() => setSelectedCategory(category.id)}
                    className={`px-6 py-3 rounded-full font-semibold transition-all whitespace-nowrap cursor-pointer ${
                      selectedCategory === category.id
                        ? 'bg-zinc-800 text-white shadow-lg'
                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                    }`}
                  >
                    {category.name}
                  </button>
                ))}
              </div>
            </div>
          </section>

          {/* Products Grid */}
          <section className="py-20 bg-gray-50">
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {filteredProducts.map((product) => (
                  <div
                    key={product.id}
                    className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
                    data-product-shop
                  >
                    {/* Product Image */}
                    <div className="aspect-w-4 aspect-h-5">
                      <img
                        src={product.image}
                        alt={product.name}
                        className="w-full h-64 object-cover object-center"
                      />
                    </div>

                    {/* Product Content */}
                    <div className="p-8">
                      {/* Category Badge */}
                      <div className="mb-4">
                        <span className="inline-block px-3 py-1 bg-rose-100 text-rose-800 text-xs font-semibold rounded-full uppercase tracking-wider">
                          {categories.find(cat => cat.id === product.category)?.name}
                        </span>
                      </div>

                      {/* Product Name */}
                      <h3 className="text-xl font-bold text-zinc-800 mb-3">
                        {product.name}
                      </h3>

                      {/* Description */}
                      <p className="text-gray-600 mb-4 leading-relaxed">
                        {product.description}
                      </p>

                      {/* Features */}
                      <div className="mb-6">
                        <h4 className="text-sm font-semibold text-zinc-800 mb-2">Eigenschaften:</h4>
                        <ul className="grid grid-cols-2 gap-1 text-sm text-gray-600">
                          {product.features.map((feature, index) => (
                            <li key={index} className="flex items-center">
                              <i className="ri-check-line text-green-500 mr-1 text-xs"></i>
                              {feature}
                            </li>
                          ))}
                        </ul>
                      </div>

                      {/* Sizes */}
                      <div className="mb-6">
                        <h4 className="text-sm font-semibold text-zinc-800 mb-2">Verfügbare Optionen:</h4>
                        <div className="flex flex-wrap gap-2">
                          {product.sizes.map((size, index) => (
                            <span key={index} className="px-2 py-1 bg-gray-100 text-gray-700 text-xs rounded">
                              {size}
                            </span>
                          ))}
                        </div>
                      </div>

                      {/* CTA Button */}
                      <a
                        href="/kontakt"
                        className="w-full inline-flex items-center justify-center px-6 py-3 border-2 border-zinc-800 text-zinc-800 font-semibold rounded-lg hover:bg-zinc-800 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                      >
                        Anfrage senden
                        <i className="ri-mail-line ml-2"></i>
                      </a>
                    </div>
                  </div>
                ))}
              </div>

              {/* Bottom CTA */}
              <div className="text-center mt-16">
                <div className="bg-white rounded-2xl p-8 max-w-4xl mx-auto shadow-xl">
                  <h3 className="text-2xl font-bold text-zinc-800 mb-4">
                    Individuellen Artikel nicht gefunden?
                  </h3>
                  <p className="text-gray-600 text-lg mb-6">
                    Wir fertigen auch maßgeschneiderte Promotion-Artikel nach Ihren exakten Vorgaben. 
                    Kontaktieren Sie uns für eine persönliche Beratung.
                  </p>
                  <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <a
                      href="/kontakt"
                      className="inline-flex items-center justify-center px-8 py-4 bg-zinc-800 text-white font-semibold rounded-lg hover:bg-zinc-900 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      Individuelle Anfrage
                      <i className="ri-arrow-right-line ml-2"></i>
                    </a>
                    <a
                      href="tel:+4917296060061"
                      className="inline-flex items-center justify-center px-8 py-4 border-2 border-zinc-800 text-zinc-800 font-semibold rounded-lg hover:bg-zinc-800 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                    >
                      Telefonberatung
                      <i className="ri-phone-line ml-2"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}
